import React, { FunctionComponent, useEffect } from 'react'
import Amplitude from '../../utils/amplitudeHelper'
import { AgendaStyle } from './styled'
import logo from '../../images/backdrops/header_title.png'
import config from 'src/config'
import { CurrentUserType } from 'src/ducks/auth'
import Programme from 'src/components/Agenda/Programme'

interface DesktopAgendaTypes {
  currentUser: CurrentUserType
}

const DesktopAgenda: FunctionComponent<DesktopAgendaTypes> = ({ currentUser }) => {
  useEffect(() => {
    document.title = `${config.eventName} | Programme`
  }, [])

  useEffect(() => {
    Amplitude.visit('Programme Page')
  }, [currentUser.id])

  return (
    <AgendaStyle>
      <header className="header-banner">
        <div className="w-100 mx-0">
          <img src={logo} width="50%" className="d-block mx-auto" alt="event logo" />
        </div>
      </header>

      <div className="container">
        <Programme defaultDay={null} defaultHall={null} />
      </div>
    </AgendaStyle>
  )
}

export default DesktopAgenda